var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplorador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.9 156.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#Degradado_sin_nombre_6-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#Degradado_sin_nombre_6);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Degradado_sin_nombre_20-5);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #e2e2e2;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #0a3144;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#Degradado_sin_nombre_6-7);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#Degradado_sin_nombre_20-2);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#Degradado_sin_nombre_20-3);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#Degradado_sin_nombre_20-8);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#Degradado_sin_nombre_6-6);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: none;\r\n        stroke: #0a3144;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: .5px;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#Degradado_sin_nombre_2);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#Degradado_sin_nombre_20);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#Degradado_sin_nombre_6-3);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#Degradado_sin_nombre_20-4);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#Degradado_sin_nombre_20-9);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#Degradado_sin_nombre_6-4);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#Degradado_sin_nombre_20-7);\r\n      }\r\n\r\n      .cls-20 {\r\n        font-family: Roboto-Regular, 'Roboto Regular';\r\n        font-size: 8.67px;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#Degradado_sin_nombre_20-6);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#Degradado_sin_nombre_6-5);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    "data-name": "Degradado sin nombre 6",
    x1: 68.68,
    y1: 23.57,
    x2: 88.22,
    y2: 23.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d1669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7251b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20",
    "data-name": "Degradado sin nombre 20",
    x1: 26.56,
    y1: 89.01,
    x2: 130.35,
    y2: 89.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d2d9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e0e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-2",
    "data-name": "Degradado sin nombre 6",
    x1: 24.89,
    y1: 89.01,
    x2: 132.01,
    y2: 89.01,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-2",
    "data-name": "Degradado sin nombre 20",
    x1: 57.76,
    y1: 89.01,
    x2: 99.15,
    y2: 89.01,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-3",
    "data-name": "Degradado sin nombre 20",
    x1: 57.84,
    y1: 78.67,
    x2: 78.45,
    y2: 78.67,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-4",
    "data-name": "Degradado sin nombre 20",
    x1: 40.39,
    y1: 89.01,
    x2: 116.52,
    y2: 89.01,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-5",
    "data-name": "Degradado sin nombre 20",
    x1: 40.39,
    y1: 86.37,
    x2: 78.45,
    y2: 86.37,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-6",
    "data-name": "Degradado sin nombre 20",
    x1: 73.16,
    y1: 108.05,
    x2: 78.45,
    y2: 108.05,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-7",
    "data-name": "Degradado sin nombre 20",
    x1: 78.45,
    y1: 91.67,
    x2: 116.09,
    y2: 91.67,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-8",
    "data-name": "Degradado sin nombre 20",
    x1: 78.45,
    y1: 69.98,
    x2: 83.75,
    y2: 69.98,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-3",
    "data-name": "Degradado sin nombre 6",
    x1: 57.48,
    y1: 87.51,
    x2: 103.17,
    y2: 87.51,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    "data-name": "Degradado sin nombre 2",
    x1: 61.28,
    y1: 94.34,
    x2: 85.66,
    y2: 94.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e55566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-9",
    "data-name": "Degradado sin nombre 20",
    x1: 74.79,
    y1: 80.75,
    x2: 99.36,
    y2: 80.75,
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-4",
    "data-name": "Degradado sin nombre 6",
    x1: 35.2,
    y1: 65.62,
    x2: 74.91,
    y2: 65.62,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-5",
    "data-name": "Degradado sin nombre 6",
    x1: 81.98,
    y1: 112.41,
    x2: 121.71,
    y2: 112.41,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-6",
    "data-name": "Degradado sin nombre 6",
    x1: 35.2,
    y1: 112.41,
    x2: 74.91,
    y2: 112.41,
    xlinkHref: "#Degradado_sin_nombre_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6-7",
    "data-name": "Degradado sin nombre 6",
    x1: 81.98,
    y1: 65.62,
    x2: 121.71,
    y2: 65.62,
    xlinkHref: "#Degradado_sin_nombre_6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 73.63,
    y: 30.9,
    width: 9.64,
    height: 4.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m78.45,13.8c-5.4,0-9.77,4.38-9.77,9.77s4.37,9.77,9.77,9.77,9.77-4.38,9.77-9.77-4.38-9.77-9.77-9.77Zm0,17.11c-4.06,0-7.34-3.29-7.34-7.34s3.29-7.34,7.34-7.34,7.34,3.29,7.34,7.34-3.29,7.34-7.34,7.34Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m130.35,89.01c0,28.66-23.24,51.89-51.89,51.89s-51.89-23.23-51.89-51.89,23.23-51.89,51.89-51.89,51.89,23.23,51.89,51.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.45,142.57c-29.53,0-53.56-24.03-53.56-53.56s24.03-53.56,53.56-53.56,53.56,24.03,53.56,53.56-24.03,53.56-53.56,53.56Zm0-103.78c-27.69,0-50.22,22.53-50.22,50.22s22.53,50.22,50.22,50.22,50.22-22.53,50.22-50.22-22.53-50.22-50.22-50.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 78.45,
    cy: 89.01,
    r: 43.25,
    transform: "translate(-18.47 20.57) rotate(-13.38)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "99.07 109.7 80.94 96.57 80.85 96.5 80.85 96.5 78.45 94.76 58.05 109.42 57.76 109.63 70.97 91.41 72.71 89.01 58.05 68.61 57.84 68.32 76.05 81.53 78.45 83.27 98.86 68.61 99.15 68.4 85.94 86.62 84.2 89.02 98.87 109.44 99.07 109.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "78.45 89.02 58.05 68.61 57.84 68.32 76.05 81.53 78.45 89.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.45 89.02 58.05 109.42 57.76 109.63 70.97 91.41 78.45 89.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.85 96.5 80.85 96.5 78.45 89.02 98.87 109.44 80.85 96.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "85.94 86.62 78.45 89.02 98.86 68.61 99.15 68.4 85.94 86.62"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "116.52 89.09 87.71 93.68 87.57 93.71 87.56 93.71 83.75 94.31 78.45 126.63 78.38 127.08 73.76 98.13 73.16 94.31 40.84 89.02 40.39 88.94 69.34 84.33 73.16 83.72 78.45 51.4 78.53 50.95 83.14 79.91 83.75 83.72 116.09 89.02 116.52 89.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "78.45 89.02 40.84 89.02 40.39 88.94 73.16 83.72 78.45 89.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "78.45 89.02 78.45 126.63 78.38 127.08 73.16 94.31 78.45 89.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "87.57 93.71 83.75 94.31 78.45 89.02 116.09 89.02 87.57 93.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "83.75 83.72 78.45 89.02 78.45 51.4 78.53 50.95 83.75 83.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.39,89.02c0,1.62-1.32,2.94-2.94,2.94s-2.94-1.32-2.94-2.94,1.32-2.94,2.94-2.94,2.94,1.32,2.94,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m80.32,89.02c0,1.03-.84,1.87-1.87,1.87s-1.87-.84-1.87-1.87.84-1.87,1.87-1.87,1.87.84,1.87,1.87Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(75.67 53.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(36.66 91.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(75.67 130.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(116.09 91.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "73.73 81.28 103.17 65.11 86.91 93.74 57.48 109.9 73.73 81.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.36 68.87 85.86 92.64 85.85 92.66 61.28 106.15 74.79 82.36 99.36 68.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "74.69 82.54 85.66 92.77 61.28 106.15 74.69 82.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "99.36 68.87 85.86 92.64 74.79 82.36 99.36 68.87"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m35.76,85.48s-.03,0-.05,0c-.31-.03-.53-.3-.5-.61,1.95-20.71,18.4-37.17,39.1-39.12.31-.03.58.2.61.5.03.31-.2.58-.5.61-20.18,1.9-36.2,17.93-38.1,38.11-.03.29-.27.5-.55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m82.54,132.27c-.28,0-.53-.22-.55-.5-.03-.31.2-.58.5-.61,20.19-1.9,36.21-17.93,38.11-38.1.03-.3.3-.54.61-.5.31.03.53.3.5.61-1.95,20.71-18.4,37.15-39.12,39.1-.01,0-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m74.36,132.27s-.03,0-.05,0c-20.71-1.95-37.15-18.4-39.1-39.1-.03-.31.19-.58.5-.61.31-.04.58.2.61.5,1.9,20.18,17.93,36.2,38.1,38.1.31.03.53.3.5.61-.03.29-.27.5-.55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m121.15,85.48c-.28,0-.52-.22-.55-.5-1.9-20.18-17.93-36.21-38.11-38.11-.31-.03-.53-.3-.5-.61.03-.31.3-.53.61-.5,20.72,1.95,37.17,18.4,39.12,39.12.03.31-.2.58-.5.61-.02,0-.03,0-.05,0Z"
  })))), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 78.45,
    y1: 38.79,
    x2: 78.45,
    y2: 40.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 53.33,
    y1: 45.41,
    x2: 54.33,
    y2: 47.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 34.93,
    y1: 63.76,
    x2: 36.66,
    y2: 64.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 28.23,
    y1: 89.02,
    x2: 30.23,
    y2: 89.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 35,
    y1: 114.28,
    x2: 36.73,
    y2: 113.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 53.43,
    y1: 132.7,
    x2: 54.43,
    y2: 130.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 78.95,
    y1: 139.24,
    x2: 78.95,
    y2: 137.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 104.11,
    y1: 132.27,
    x2: 103.12,
    y2: 130.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 122.26,
    y1: 113.65,
    x2: 120.53,
    y2: 112.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 128.67,
    y1: 88.52,
    x2: 126.68,
    y2: 88.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 121.86,
    y1: 63.56,
    x2: 120.13,
    y2: 64.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 103.47,
    y1: 45.36,
    x2: 102.47,
    y2: 47.09
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorador);
export default __webpack_public_path__ + "static/media/explorador.f07b5b1a845e8259442d6e8aea507b72.svg";
export { ForwardRef as ReactComponent };